import { MouseEvent } from 'react';

import { ReactComponent as PresenceIcon } from 'assets/icons/presence.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { getPresenceNameAreaWidth } from '../CurrentPresence.variables';

import { PresenceZoneItemProps } from './PresenceZoneItem.types';
import * as Styled from './PresenceZoneItem.styles';

export const PresenceZoneItem = ({ zone, onShowOwners }: PresenceZoneItemProps) => {
  const { formatMessage } = useLocale();
  const hasChildren = zone.children.length > 0;

  const handleShowOwners = (event: MouseEvent) => {
    event.stopPropagation();
    onShowOwners?.(zone);
  };

  return (
    <Styled.TreeItem
      nodeId={zone.id}
      label={
        <Styled.LabelWrapper
          data-testid={`presence-zone-${zone.kod}`}
          $nameAreaWidth={getPresenceNameAreaWidth(zone.poziom)}
        >
          <Styled.TextWrapper>
            <Styled.Code>{zone.kod}</Styled.Code>
            <Styled.Name>{zone.nazwa}</Styled.Name>
          </Styled.TextWrapper>
          {/* Empty cell under the "ILOŚĆ OSÓB" header label. */}
          <span />
          <Styled.Counter data-testid={`presence-zone-${zone.kod}-strefa`}>{zone.liczbaOsob.strefa}</Styled.Counter>
          <Styled.Counter data-testid={`presence-zone-${zone.kod}-podstrefy`}>
            {zone.liczbaOsob.podstrefy}
          </Styled.Counter>
          <Styled.Counter data-testid={`presence-zone-${zone.kod}-lacznie`}>{zone.liczbaOsob.lacznie}</Styled.Counter>
          <Styled.ActionWrapper>
            <Styled.ShowOwnersButton
              data-testid={`presence-zone-${zone.kod}-owners`}
              aria-label={formatMessage({ id: AppMessages['events.currentPresence.showOwners'] })}
              onClick={handleShowOwners}
            >
              <PresenceIcon />
            </Styled.ShowOwnersButton>
          </Styled.ActionWrapper>
        </Styled.LabelWrapper>
      }
    >
      {hasChildren
        ? zone.children.map((child) => <PresenceZoneItem key={child.id} zone={child} onShowOwners={onShowOwners} />)
        : null}
    </Styled.TreeItem>
  );
};
